<template>
  <div class="headrating">
    <div class="headrating__item" :uk-tooltip="scores" v-if="user && user.role.code === 'student'">
      <img src="storage/app/media/star.svg" alt="">
      <span class="uk-visible@s">{{ user.scores ? user.scores : 0 }}</span>
    </div>
    <div class="headrating__item headrating__item--hand" @click="showCoinsDesc" :uk-tooltip="coins" v-if="user && user.role.code === 'student' && user.is_outside === 0">
      <img src="storage/app/media/coin.svg" alt="">
      <span class="uk-visible@s">{{ user.coin_balance ? user.coin_balance : 0 }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "headrating",
  data() {
    return {}
  },
  props: {
    items: ''
  },
  computed: {
    scores() {
      let user = this.user;
      let scores = 'Баллов ' + (user.scores ? user.scores : 0);
      //let status = (_.isEmpty(user.status) ? '' : '. Статус ' + user.status.title);
      return scores;
    },
    coins() {
      let user = this.user;
      return 'Дженкоинов ' + (user.coin_balance ? user.coin_balance : 0);
    },
    user() {
      return this.$store.state.user;
    }
  },
  methods: {
    showCoinsDesc() {
      let message = "Регулярно выполняйте домашние задания и зарабатывайте дженкоины. Чтобы получить 1 дженкоин, нужно выполнять домашнее задание 2 дня подряд с общим результатом больше 70% правильных ответов!";
      let message2 = "Накопленные дженкоины вы можете потратить в магазине подарков на платформе. Чтобы совершить покупку, необходимо также перейти в новый уровень. В каждом уровне доступна одна покупка.";
      UIkit.modal.dialog('<h2>Зарабатывайте дженкоины!</h2>' +
          `<p class="uk-text-center">${message}</p><p class="uk-text-center">${message2}</p>`);
    }
  }
}
</script>